/**
 * Scroll reveals shared by the Monarch homepage sections.
 *
 * Each band is its own section, so rather than every section shipping its own observer this
 * watches `[data-mh-reveal]` across the page. Elements above the fold are revealed on a short
 * stagger instead of waiting for an intersection that has already happened.
 */

const MONARCH_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

function initMonarchReveals() {
  if (MONARCH_MOTION.matches) return;

  const targets = document.querySelectorAll('[data-mh-reveal]:not(.is-in):not(.is-pending)');
  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
  );

  for (const target of targets) {
    target.classList.add('is-pending');
    observer.observe(target);
  }

  // Anything already in view on load gets a staggered entrance rather than appearing at once.
  const viewportHeight = window.innerHeight;
  let staggerIndex = 0;
  for (const target of targets) {
    if (target.getBoundingClientRect().top > viewportHeight) continue;
    const delay = 120 + staggerIndex * 130;
    staggerIndex += 1;
    window.setTimeout(() => {
      target.classList.add('is-in');
      observer.unobserve(target);
    }, delay);
  }
}

initMonarchReveals();

// Re-run when the theme editor swaps a section in.
document.addEventListener('shopify:section:load', initMonarchReveals);
